import React from "react";
import '../stylesheets/Splash.css';

const Splash = ({strings}) => <div id="splash">
        <div className="content">
            <img alt="pleinair logo" src="/images/PLEINAIRCLUB_orizzontale_RGB.png" id="logo"/>
            <div className="loader"></div>
        </div>
        <div className="footer">
            <div id="copyright">{strings.copyright}</div>
            <div id="site_name">{strings.plainairclub}</div>
        </div>
    </div>

export default Splash;
